/* ============================================================
 headerスクロール
============================================================ */
$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if (scroll > 100) {
        $(".l-header").addClass("is-active");
    }
    else {
        $(".l-header").removeClass("is-active");
    }
});


$(function(){
/* ============================================================
 スムーススクロール
============================================================ */
    $('a[href^="#"]').click(function () {
        var speed = 500;
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top;
        $("html, body").animate({scrollTop:position}, speed, "swing");
        return false;
    });

/* ============================================================
 SP Nav
============================================================ */
    $('#hbg').click(function() {
        $(this).toggleClass('is-active');
        if ($(this).hasClass('is-active')) {
            $('.sp-header-cont-inner').addClass('is-active');
        } else {
            $('.sp-header-cont-inner').removeClass('is-active');
        }
    });

    $('.sp-header-cont-inner a[href]').on('click', function(event) {
        $('#hbg').trigger('click');
    });

/* ============================================================
 mailmag btn
============================================================ */
    var mailMag = $('.js-mag-btn');
    mailMag.hide();
    //スクロールが300に達したらボタン表示
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            mailMag.fadeIn();
        } else {
            mailMag.fadeOut();
        }
    });
    // フッター手前でストップ
    $(".js-mag-btn").hide();
    $(window).on("scroll", function () {
      scrollHeight = $(document).height();
      scrollPosition = $(window).height() + $(window).scrollTop();
      footHeight = $("footer").innerHeight() - 60;
      if (scrollHeight - scrollPosition <= footHeight) {
      // ページトップボタンがフッター手前に来たらpositionとfixedからabsoluteに変更
        $("body").css({
          position: "relative"
        });
        $(".js-mag-btn").css({
          position: "absolute",
          bottom: footHeight + 60
        });
      } else {
        $(".js-mag-btn").css({
          position: "fixed",
          bottom: "60px"
        });
      }
    });


});



$(function(){
  /* ============================================================
   既存のコード全部（スムーススクロール、SP Nav、mailmag btn など）
  ============================================================ */
  // ... ここまで既存 ...

  /* ============================================================
   ブランドスライドショー
  ============================================================ */
  const slideshow = document.querySelector('.brand-slideshow');
  if (!slideshow) return;  // 要素がないページでは何もしない（エラー防止）

  const slides = document.querySelectorAll('.brand-slide');
  const dotsContainer = document.querySelector('.brand-dots');

  let currentIndex = 0;
  let intervalId = null;
  const intervalTime = 5000;

  function createDots() {
    dotsContainer.innerHTML = '';
    slides.forEach((_, i) => {
      const dot = document.createElement('div');
      dot.classList.add('brand-dot');
      dot.addEventListener('click', () => {
        goToSlide(i);
      });
      dotsContainer.appendChild(dot);
    });
    updateDots();
  }

  function updateDots() {
    const dots = dotsContainer.querySelectorAll('.brand-dot');
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === currentIndex);
    });
  }

  function showSlide(index) {
    slides.forEach(slide => slide.classList.remove('active'));
    slides[index].classList.add('active');
    currentIndex = index;
    updateDots();
  }

  function goToSlide(index) {
    if (index === currentIndex) return;
    clearInterval(intervalId);
    showSlide(index);
    startAutoPlay();
  }

  function nextSlide() {
    let next = currentIndex + 1;
    if (next >= slides.length) next = 0;
    showSlide(next);
  }

  function startAutoPlay() {
    clearInterval(intervalId);
    intervalId = setInterval(nextSlide, intervalTime);
  }

  function init() {
    if (slides.length === 0) return;
    createDots();
    showSlide(0);
    startAutoPlay();

    slideshow.addEventListener('mouseenter', () => clearInterval(intervalId));
    slideshow.addEventListener('mouseleave', startAutoPlay);
  }

  init();
});